module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<tr class=\"ctrl-psel-item\">\n    ")
    ;  if (item.icon) { 
    ; __append("\n    <td class=\"icon\">\n        <img src=\"")
    ; __append(escapeFn( item.icon ))
    ; __append("\" />\n    </td>\n    ")
    ;  } 
    ; __append("\n    ")
    ;  control.columns.forEach(function(column) { 
    ; __append("\n    <td>\n        ")
    ; __append(escapeFn( _.get(item, column.name) ))
    ; __append("\n    </td>\n    ")
    ;  }) 
    ; __append("\n    ")
    ;  if (control.multiple) { 
    ; __append("\n    <td>\n        <a href=\"#\" class=\"remove icon-16 icon-close\" data-id=\"")
    ; __append(escapeFn( item.id ))
    ; __append("\"\n           style=\"position: absolute; top: 2px; right: 2px;\"></a>\n    </td>\n    ")
    ;  } 
    ; __append("\n</tr>\n")
  }
  return __output.join("");

}